import { NgModule } from "@angular/core";
import { DragDropDirective } from "./drag-drop.directive";
import { ValueObjectValidatorDirective } from "./value-object-validator.directive";
import { OnFocusSelectAllTextDirective } from "./on-focus-select-all-text.directive";
import { DecimalNumberDirective } from "./decimal-number.directive";

@NgModule({
  imports: [],
  declarations: [DecimalNumberDirective, OnFocusSelectAllTextDirective, DragDropDirective, ValueObjectValidatorDirective],
  exports: [DecimalNumberDirective, OnFocusSelectAllTextDirective, DragDropDirective, ValueObjectValidatorDirective]
})
export class AppDirectivesModule { }